import React, { useEffect, useRef, useState } from 'react';
import { Text, Link, Avatar, IconAction, Divider, Button } from '../../..';
import { HelpCircle, ShoppingCart, Briefcase, Tag, Share2, Wallet, Bell, Heart, Money, X } from '../Icons';
import { ChevronRight } from '@olxbr/ds-icons';
import { sendClickEvent } from '../../utils';
import { useFavoritesAds, useMyAds, useScrollLock } from '../../services';
import { IconButton } from '../IconButton';
import * as Styles from './styles';
/**
 * Componente OverflowMenu do Design System OLX
 */
export const OverflowMenu = _ref => {
  let {
    visible,
    accountInfo,
    onHide,
    notifications
  } = _ref;
  const {
    userName,
    profilePicture
  } = accountInfo;
  const [focusedFirstElement, setFocusedFirstElement] = useState(false);
  const wrapperRef = useRef(null);
  const [myAds, myAdsLoading] = useMyAds();
  const [favoriteAds, favoriteAdsLoading] = useFavoritesAds();
  const {
    unlockScroll,
    lockScroll
  } = useScrollLock();
  const focusOnProfile = () => {
    const profile = document.querySelector('.profile-link');
    profile === null || profile === void 0 ? void 0 : profile.focus();
  };
  useEffect(() => {
    if (!visible) {
      setFocusedFirstElement(false);
      unlockScroll();
    } else {
      lockScroll();
    }
  }, [lockScroll, unlockScroll, visible]);
  useEffect(() => {
    const handleNavigation = event => {
      var _a;
      if (event.key !== 'Tab' && event.key !== 'Escape' && event.shiftKey && !visible) {
        return;
      }
      const elementsToNavigate = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('a[href], button');
      const firstElement = elementsToNavigate.item(0);
      const lastElement = elementsToNavigate.item(elementsToNavigate.length - 1);
      if (!event.shiftKey && event.key === 'Tab' && !focusedFirstElement && visible) {
        event.preventDefault();
        firstElement.focus();
        return setFocusedFirstElement(true);
      }
      if (event.key === 'Escape') {
        focusOnProfile();
        return onHide();
      }
      if (!event.shiftKey && event.key === 'Tab' && event.target === lastElement) {
        event.preventDefault();
        return firstElement.focus();
      }
      if (event.shiftKey && event.key === 'Tab' && event.target === firstElement) {
        event.preventDefault();
        return lastElement.focus();
      }
    };
    window.addEventListener('keydown', handleNavigation);
    return () => {
      window.removeEventListener('keydown', handleNavigation);
    };
  }, [focusedFirstElement, onHide, visible]);
  return React.createElement(React.Fragment, null, React.createElement(Styles.OverflowMenuBackdrop, {
    className: visible ? 'overflow-menu-backdrop--visible' : '',
    onClick: onHide,
    "data-testid": "overflow-menu-backdrop",
    "aria-hidden": !visible
  }), React.createElement(Styles.OverflowMenuSurface, {
    "data-ds-component": "DS-OverflowMenu",
    "aria-label": "Menu suspenso",
    "aria-hidden": !visible,
    ref: wrapperRef,
    tabIndex: !visible ? -1 : undefined
  }, React.createElement(Styles.OverflowMenuContent, null, React.createElement(IconButton, {
    className: "icon-button-close",
    "aria-label": "Fechar",
    onClick: () => {
      onHide();
      focusOnProfile();
    }
  }, React.createElement(X, null)), React.createElement(Styles.WrapperHeader, null, React.createElement(Styles.HeaderLeft, null, React.createElement(Text.TitleMedium, null, "Ol\u0227, ", userName), React.createElement(Link, {
    dsParentName: "Header",
    className: "link-config",
    variant: "grey",
    size: "medium",
    href: "https://conta.olx.com.br/meu-cadastro",
    tabIndex: visible ? 0 : -1,
    onClick: () => sendClickEvent('conta', 'sub_menu')
  }, "Configura\u00E7\u00F5es")), React.createElement(Avatar, {
    dsParentName: "Header",
    size: "56px",
    src: profilePicture
  })), React.createElement(Link, {
    dsParentName: "Header",
    className: "link-seguro",
    variant: "grey",
    href: "https://planoprofissional.olx.com.br/",
    size: "medium",
    tabIndex: visible ? 0 : -1,
    onClick: () => sendClickEvent('banner', 'sub_menu', {
      banner_item: true
    })
  }, React.createElement("span", null, "Quer impulsionar suas vendas ?"), React.createElement("span", {
    className: "text-seguro-colored"
  }, "Veja os planos"), React.createElement(ChevronRight, {
    "aria-hidden": "true"
  })), React.createElement(Styles.WrapperIconLinks, {
    tabIndex: !visible ? -1 : undefined
  }, React.createElement(Styles.IconItem, null, React.createElement(IconAction, {
    size: "large",
    label: "Me ajuda",
    widthLabel: "60px",
    href: "https://www.olx.com.br/faq.htm",
    bgColor: "--color-neutral-100",
    icon: React.createElement(HelpCircle, {
      color: "var(--color-neutral-130)"
    }),
    tabIndex: visible ? 0 : -1,
    onClick: () => sendClickEvent('help_me', 'sub_menu')
  })), React.createElement(Styles.IconItem, null, React.createElement(IconAction, {
    size: "large",
    label: "Minhas vendas",
    widthLabel: "50px",
    href: "https://meus-pedidos.olx.com.br/minhas-vendas",
    bgColor: "--color-neutral-100",
    icon: React.createElement(Tag, {
      color: "var(--color-neutral-130)"
    }),
    tabIndex: visible ? 0 : -1,
    onClick: () => sendClickEvent('olx_pay_seller_orders', 'sub_menu')
  })), React.createElement(Styles.IconItem, null, React.createElement(IconAction, {
    size: "large",
    label: "Minhas compras",
    widthLabel: "54px",
    href: "https://meus-pedidos.olx.com.br/minhas-compras",
    bgColor: "--color-neutral-100",
    icon: React.createElement(ShoppingCart, {
      color: "var(--color-neutral-130)"
    }),
    tabIndex: visible ? 0 : -1,
    onClick: () => sendClickEvent('olx_pay_buyer_orders', 'sub_menu')
  })), React.createElement(Styles.IconItem, null, React.createElement(IconAction, {
    size: "large",
    label: "Pagamentos",
    widthLabel: "80px",
    href: "https://conta.olx.com.br/pagamentos",
    bgColor: "--color-neutral-100",
    icon: React.createElement(Money, {
      color: "var(--color-neutral-130)"
    }),
    tabIndex: visible ? 0 : -1,
    onClick: () => sendClickEvent('payment_central', 'sub_menu')
  })), React.createElement(Styles.IconItem, null, React.createElement(IconAction, {
    size: "large",
    label: "Planos profissionais",
    widthLabel: "80px",
    href: "https://planoprofissional.olx.com.br/",
    bgColor: "--color-neutral-100",
    icon: React.createElement(Briefcase, {
      color: "var(--color-neutral-130)"
    }),
    tabIndex: visible ? 0 : -1,
    onClick: () => sendClickEvent('my_plan', 'sub_menu')
  })), React.createElement(Styles.IconItem, null, React.createElement(IconAction, {
    size: "large",
    label: "Favoritos",
    href: "https://www3.olx.com.br/account/favorites",
    bgColor: "--color-neutral-100",
    icon: React.createElement(Heart, {
      color: "var(--color-neutral-130)"
    }),
    tabIndex: visible ? 0 : -1,
    onClick: () => sendClickEvent('favorite_ads', 'sub_menu')
  })), React.createElement(Styles.IconItem, null, React.createElement(IconAction, {
    size: "large",
    label: "Notifica\u00E7\u00E3o",
    href: "https://conta.olx.com.br/notificacoes",
    bgColor: "--color-neutral-100",
    icon: React.createElement(Bell, {
      color: "var(--color-neutral-130)"
    }),
    tabIndex: visible ? 0 : -1,
    notification: notifications,
    onClick: () => sendClickEvent('notification', 'sub_menu')
  })), React.createElement(Styles.IconItem, null, React.createElement(IconAction, {
    size: "large",
    label: "Carteira OLX Pay",
    widthLabel: "64px",
    href: "https://wallet.olx.com.br/",
    bgColor: "--color-neutral-100",
    icon: React.createElement(Wallet, {
      color: "var(--color-neutral-130)"
    }),
    tabIndex: visible ? 0 : -1,
    onClick: () => sendClickEvent('wallet', 'sub_menu')
  })), React.createElement(Styles.IconItem, null, React.createElement(IconAction, {
    size: "large",
    label: "Compartilhar perfil",
    widthLabel: "85px",
    href: "https://www.olx.com.br/perfil/".concat(accountInfo.publicAccountId),
    bgColor: "--color-neutral-100",
    icon: React.createElement(Share2, {
      color: "var(--color-neutral-130)"
    }),
    tabIndex: visible ? 0 : -1,
    onClick: () => sendClickEvent('profile_page', 'sub_menu')
  }))), React.createElement(Styles.WrapperMyAds, null, React.createElement(Styles.SectionsHeader, null, React.createElement(Text.TitleMedium, {
    tag: "h2"
  }, "Meus an\u00FAncios"), React.createElement(Link, {
    dsParentName: "Header",
    variant: "grey",
    size: "medium",
    className: "see-all-link",
    tabIndex: visible ? 0 : -1,
    href: "https://conta.olx.com.br/anuncios/publicados",
    onClick: () => sendClickEvent('my_ads', 'sub_menu'),
    "aria-label": "Ver todos os meus an\u00FAncios"
  }, "Ver todos")), React.createElement(Styles.MyAdsContent, {
    className: !myAdsLoading && myAds.length === 0 ? 'empty' : ''
  })), React.createElement(Styles.WrapperFavoriteAds, null, React.createElement(Styles.SectionsHeader, null, React.createElement(Text.TitleMedium, {
    tag: "h2"
  }, "Favoritos"), React.createElement(Link, {
    dsParentName: "Header",
    variant: "grey",
    size: "medium",
    className: "see-all-link",
    tabIndex: visible ? 0 : -1,
    href: "https://www3.olx.com.br/account/favorites",
    onClick: () => sendClickEvent('favorite_ads', 'sub_menu'),
    "aria-label": "Ver todos os meus favoritos"
  }, "Ver todos")), React.createElement(Styles.FavoritesContent, {
    className: !favoriteAdsLoading && favoriteAds.length === 0 ? 'empty' : ''
  })), React.createElement(Styles.WrapperConfig, null, React.createElement(Text.TitleMedium, {
    tag: "h2"
  }, "Configura\u00E7\u00F5es"), React.createElement(Styles.ConfigItems, {
    tabIndex: !visible ? -1 : undefined
  }, React.createElement(Styles.ConfigItem, null, React.createElement(Button, {
    dsParentName: "Header",
    tag: "a",
    href: "https://www3.olx.com.br/account/form_userinfo",
    variant: "neutral",
    size: "medium",
    tabIndex: visible ? 0 : -1,
    onClick: () => sendClickEvent('conta', 'sub_menu')
  }, "Informa\u00E7\u00F5es pessoais")), React.createElement(Styles.ConfigItem, null, React.createElement(Button, {
    dsParentName: "Header",
    tag: "a",
    href: "https://conta.olx.com.br/seguranca",
    variant: "neutral",
    size: "medium",
    tabIndex: visible ? 0 : -1,
    onClick: () => sendClickEvent('security_central', 'sub_menu')
  }, "Seguran\u00E7a e privacidade")), React.createElement(Styles.ConfigItem, null, React.createElement(Button, {
    dsParentName: "Header",
    tag: "a",
    href: "https://conta.olx.com.br/pagamentos",
    variant: "neutral",
    size: "medium",
    tabIndex: visible ? 0 : -1,
    onClick: () => sendClickEvent('payment_central', 'sub_menu')
  }, "Pagamentos")), React.createElement(Styles.ConfigItem, null, React.createElement(Button, {
    dsParentName: "Header",
    tag: "a",
    href: "https://conta.olx.com.br/comunicacoes",
    variant: "neutral",
    size: "medium",
    tabIndex: visible ? 0 : -1,
    onClick: () => sendClickEvent('communication', 'sub_menu')
  }, "Prefer\u00EAncias de notifica\u00E7\u00E3o")))), React.createElement(Divider, {
    marginTop: "--spacing-4",
    marginBottom: "--spacing-4"
  }), React.createElement(Styles.WrapperFooter, null, React.createElement(Styles.FooterItem, null, React.createElement(Link, {
    dsParentName: "Header",
    href: "https://ajuda.olx.com.br/s/article/politica-de-privacidade",
    variant: "grey",
    size: "medium",
    tabIndex: visible ? 0 : -1,
    onClick: () => sendClickEvent('privacy_policy', 'sub_menu')
  }, "Pol\u00EDtica de privacidade")), React.createElement(Styles.FooterItem, null, React.createElement(Link, {
    dsParentName: "Header",
    href: "https://seguranca.olx.com.br/?ic=prod-mkt&local=footer_web&campaign=hubseguranca&message=footer_web",
    variant: "grey",
    size: "medium",
    tabIndex: visible ? 0 : -1,
    onClick: () => sendClickEvent('safety_tips', 'sub_menu')
  }, "Dicas de seguran\u00E7a")), React.createElement(Styles.FooterItem, null, React.createElement(Link, {
    dsParentName: "Header",
    href: "https://ajuda.olx.com.br/s/tema/sobre-a-olx",
    variant: "grey",
    size: "medium",
    tabIndex: visible ? 0 : -1,
    onClick: () => sendClickEvent('about_olx', 'sub_menu')
  }, "Sobre a OLX")), React.createElement(Styles.FooterItem, null, React.createElement(Link, {
    dsParentName: "Header",
    href: "https://www3.olx.com.br/account/do_logout",
    variant: "grey",
    size: "medium",
    tabIndex: visible ? 0 : -1,
    onClick: () => sendClickEvent('logout', 'sub_menu')
  }, "Sair"))))));
};
OverflowMenu.displayName = 'OverflowMenu';